import React, { useState, useEffect } from 'react';
import './style.css'; // or Commitment.css
import commit from "../../assests/About/commit.jpeg"

const commitments = [
  "At Innovation Solution, we are fully committed to delivering top-quality work while maintaining the highest safety standards.",
  "Quality and safety are our top priorities in every project we undertake.",
  "We conduct regular safety reviews, inspections, and checks in coordination with clients and contractors to ensure a safe working environment for everyone on-site.",
  "Our team stays focused on professional excellence and strives to deliver maximum value to our clients.",
  "We provide the highest quality of service in the most cost-effective manner, without compromising on safety or standards."
];

const Commitment = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % commitments.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + commitments.length) % commitments.length);
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % commitments.length);
  };

  return (
    <section className="commitment-section">
      <div className="commitment-container">
        {/* Left side image */}
        <div className="commitment-image">
          <img src={commit} alt="Commitment Visual" />
        </div>

        {/* Wavy Divider */}
        <div className="wavy-divider">
          <svg viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M 0 0 Q 100 100 100 0 L 100 100 L 0 100 Z" fill="#fffcd4" />
          </svg>
        </div>

        {/* Right side: Slideshow */}
        <div className="commitment-content">
          <h2>Our Commitment</h2>

          <div className="commitment-card-wrapper">
            <div className="arrow-button left" onClick={handlePrev}>
              &#8592;
            </div>

            <div className="commitment-card">
              <p className="fade-in" key={activeIndex}>
                {commitments[activeIndex]}
              </p>
            </div>

            <div className="arrow-button right" onClick={handleNext}>
              &#8594;
            </div>
          </div>

          {/* Dots */}
          <div className="dots-container">
            {commitments.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Commitment;
